export default [
  {
    title: 'Anasayfa',
    route: 'home',
    icon: 'HomeIcon',
    resource: 'APP_DASHBOARD',
    action: 'read',
  },
  {
    title: 'Hesap Hareketleri',
    route: '#',
    icon: 'RepeatIcon',
    children: [
      {
        title: 'Gelir Girişi',
        route: 'AccountIncomes',
        resource: 'ADMIN_ACCOUNT_ACTIVITIES',
        action: 'read',
      },
      {
        title: 'Gider Girişi',
        route: 'AccountExpenses',
        resource: 'ADMIN_ACCOUNT_ACTIVITIES',
        action: 'read',
      },
      {
        title: 'Banka Transferi',
        route: 'BankTransfer',
        resource: 'ADMIN_ACCOUNT_ACTIVITIES',
        action: 'read',
      },
      {
        title: 'Hesap Hareketleri',
        route: 'AccountActivities',
        resource: 'ADMIN_ACCOUNT_ACTIVITIES',
        action: 'read',
      },
    ],
  },
  {
    title: 'Banka Hesapları',
    route: '#',
    icon: 'ShieldIcon',
    children: [
      {
        title: 'Oluştur',
        route: 'BankAccountAdd',
        resource: 'ADMIN_BANK_ACCOUNTS',
        action: 'read',
      },
      {
        title: 'Hesap Listesi',
        route: 'BankAccounts',
        resource: 'ADMIN_BANK_ACCOUNTS',
        action: 'read',
      },
    ],
  },
  {
    title: 'Kasa Hesapları',
    route: '#',
    icon: 'InboxIcon',
    children: [
      {
        title: 'Oluştur',
        route: 'SafeAdd',
        resource: 'ADMIN_SAFES',
        action: 'read',
      },
      {
        title: 'Hesap Listesi',
        route: 'Safes',
        resource: 'ADMIN_SAFES',
        action: 'read',
      },
    ],
  },
  {
    title: 'Çek / Senet Takibi',
    route: '#',
    icon: 'FileTextIcon',
    children: [
      {
        title: 'Oluştur',
        route: 'PromissoryAdd',
        resource: 'ADMIN_PROMISSORIES',
        action: 'read',
      },
      {
        title: 'Çek / Senet Listesi',
        route: 'Promissories',
        resource: 'ADMIN_PROMISSORIES',
        action: 'read',
      },
    ],
  },
  {
    header: 'Raporlar',
    resource: 'REPORTS',
    action: 'read',
  },
  {
    title: 'Güncel Durum',
    icon: 'BookIcon',
    route: 'ReportSummary',
    resource: 'ADMIN_REPORT_SUMMARY',
    action: 'read',
  },
  {
    title: 'Gelirler Raporu',
    icon: 'ArrowRightCircleIcon',
    route: 'ReportIncomes',
    resource: 'ADMIN_REPORT_INCOMES',
    action: 'read',
  },
  {
    title: 'Giderler Raporu',
    icon: 'ArrowLeftCircleIcon',
    route: 'ReportExpenses',
    resource: 'ADMIN_REPORT_EXPENSES',
    action: 'read',
  },
  {
    title: 'Banka Raporu',
    icon: 'ShieldIcon',
    route: 'ReportBanks',
    resource: 'ADMIN_REPORT_BANKS',
    action: 'read',
  },
  {
    title: 'Kasa Raporu',
    icon: 'InboxIcon',
    route: 'ReportSafes',
    resource: 'ADMIN_REPORT_SAFES',
    action: 'read',
  },
  {
    title: 'Yönetim Raporu',
    icon: 'BoxIcon',
    route: 'ReportDirectory',
    resource: 'ADMIN_REPORT_DIRECTORY',
    action: 'read',
  },
  {
    header: 'Yönetim',
    resource: 'ADMIN',
    action: 'read',
  },
  {
    title: 'Gelir & Gider',
    route: '#',
    icon: 'BookIcon',
    children: [
      {
        title: 'Gelir Grupları',
        route: 'DonationIncomesGroups',
        resource: 'ADMIN_DONATION_GROUPS',
        action: 'read',
      },
      {
        title: 'Gider Grupları',
        route: 'DonationExpensesGroups',
        resource: 'ADMIN_DONATION_GROUPS',
        action: 'read',
      },
    ],
  },
  {
    title: 'Mülkler',
    route: 'Estates',
    icon: 'HomeIcon',
    children: [
      {
        title: 'Oluştur',
        route: 'EstateAdd',
        resource: 'ADMIN_ESTATES',
        action: 'read',
      },
      {
        title: 'Mülk Listesi',
        route: 'Estates',
        resource: 'ADMIN_ESTATES',
        action: 'read',
      },
      {
        title: 'Kiracılar',
        route: 'Tenants',
        resource: 'ADMIN_TENANTS',
        action: 'read',
      },
    ],
  },
  {
    title: 'Tanımlamalar',
    route: '#',
    icon: 'DatabaseIcon',
    children: [
      {
        title: 'Şehirler',
        route: 'Cities',
        resource: 'ADMIN_DEFINES_ALL',
        action: 'read',
      },
      {
        title: 'İlçeler',
        route: 'Districts',
        resource: 'ADMIN_DEFINES_ALL',
        action: 'read',
      },
      {
        title: 'Bankalar',
        route: 'Banks',
        resource: 'ADMIN_DEFINES_ALL',
        action: 'read',
      },
      {
        title: 'Gelir Tipleri',
        route: 'DonationTypes',
        resource: 'ADMIN_DEFINES_ALL',
        action: 'read',
      },
      {
        title: 'Hesap Tipleri',
        route: 'AccountTypes',
        resource: 'ADMIN_DEFINES_ALL',
        action: 'read',
      },
      {
        title: 'Para Birimleri',
        route: 'Currencies',
        resource: 'ADMIN_DEFINES_ALL',
        action: 'read',
      },
    ],
  },
  {
    title: 'Kullanıcılar',
    route: 'Users',
    icon: 'UsersIcon',
    children: [
      {
        title: 'Kullanıcılar',
        route: 'Users',
        resource: 'ADMIN_USERS',
        action: 'read',
      },
      {
        title: 'Kullanıcı Yetkileri',
        route: 'UserTypes',
        resource: 'ADMIN_USER_TYPES',
        action: 'read',
      },
    ],
  },
  {
    title: 'Ayarlar',
    route: '#',
    icon: 'SettingsIcon',
    children: [
      {
        title: 'SMTP',
        route: 'Smtp',
        resource: 'ADMIN_SMTP',
        action: 'read',
      },
    ],
  },
]
